/* AutoŁapka – interakcje (prefix pm-) */
(function(){
  if(window.__pmCore) return; window.__pmCore=true;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- pojawianie się --- */
  function initReveal(root){
    var els=root.querySelectorAll('.pm-reveal:not([data-ready])');
    if(!('IntersectionObserver' in window)||reduce){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){e.setAttribute('data-ready','');io.observe(e)});
  }

  /* --- odliczanie do prawdziwej daty (1 grudnia albo Wigilii) --- */
  function targetDate(kind){
    var n=new Date(),y=n.getFullYear();
    if(kind==='xmas'){var t=new Date(y,11,24);if(n>t)t=new Date(y+1,11,24);return t;}
    var d=new Date(y,11,1);
    if(n>=d){var x=new Date(y,11,24);return n<x?x:new Date(y+1,11,1);}
    return d;
  }
  function initCount(root){
    root.querySelectorAll('[data-pm-count]:not([data-ready])').forEach(function(el){
      el.setAttribute('data-ready','');
      var t=targetDate(el.getAttribute('data-pm-count'));
      var lab=el.closest('.pm-section')&&el.closest('.pm-section').querySelector('[data-pm-count-label]');
      if(lab){var isDec=new Date().getMonth()===11;lab.textContent=isDec?lab.getAttribute('data-dec'):lab.getAttribute('data-pre');}
      var u=el.querySelectorAll('b');
      function tick(){
        var s=Math.max(0,Math.floor((t-new Date())/1000));
        var v=[Math.floor(s/86400),Math.floor(s%86400/3600),Math.floor(s%3600/60),s%60];
        u.forEach(function(b,i){if(v[i]!==undefined)b.textContent=(i&&v[i]<10?'0':'')+v[i]});
      }
      tick();setInterval(tick,1000);
    });
  }

  /* --- interaktywny kalendarz 24 okienek --- */
  var BUNS=[
    {n:'Różowy Pierożek',c:'255,170,186'},{n:'Miętowy Pierożek',c:'160,224,190'},{n:'Liliowy Pierożek',c:'206,178,240'},
    {n:'Śnieżny Pierożek',c:'250,248,244'},{n:'Niebieski Pierożek',c:'120,180,250'},{n:'Cytrynowy Pierożek',c:'255,224,102'},
    {n:'Brokatowa Kulka',c:'255,140,170',g:1},{n:'Kosmiczna Kulka',c:'150,130,240',g:1},{n:'Zielona Galaktyka',c:'150,230,120',g:1},
    {n:'Serowy Gniotek',c:'255,206,84'},{n:'Żelkowa Kostka',c:'255,160,210'},{n:'Brokatowy Ptaszek',c:'176,140,240',g:1}
  ];
  function bunHTML(b,size){
    return '<div class="pm-bun'+(b.g?' pm-bun--glitter':'')+'" style="--c:'+b.c+';--s:'+size+'"><div class="pm-bun__face"><i></i><i></i><b></b><em></em><em></em></div></div>';
  }
  function initAdvent(root){
    root.querySelectorAll('[data-pm-advent]:not([data-ready])').forEach(function(wrap){
      wrap.setAttribute('data-ready','');
      var sec=wrap.closest('.pm-section')||wrap;
      var stage=sec.querySelector('[data-pm-stage]');
      var name=sec.querySelector('[data-pm-name]');
      var counter=sec.querySelector('[data-pm-opened]');
      var bar=sec.querySelector('[data-pm-bar]');
      var hint=sec.querySelector('[data-pm-hint]');
      var opened=0, now=new Date(), today=(now.getMonth()===11&&now.getDate()<=24)?now.getDate():0;
      var order=BUNS.slice();for(var i=order.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=order[i];order[i]=order[j];order[j]=t;}
      var grid=wrap; grid.innerHTML='';
      for(var d=1;d<=24;d++){
        var b=order[(d-1)%order.length];
        var cell=document.createElement('button');
        cell.type='button';cell.className='pm-door'+(d===today?' is-today':'');
        cell.setAttribute('aria-label','Okienko '+d);
        cell.innerHTML='<span class="pm-door__in">'+bunHTML(b,'72%')+'</span><span class="pm-door__lid"><span>'+d+'</span></span>';
        (function(cell,b,d){
          cell.addEventListener('click',function(){
            if(!cell.classList.contains('is-open')){cell.classList.add('is-open');opened++;}
            sec.querySelectorAll('.pm-door.is-active').forEach(function(x){x.classList.remove('is-active')});
            cell.classList.add('is-active');
            if(stage){stage.innerHTML=bunHTML(b,'min(220px,52vw)');var bun=stage.firstChild;bun.classList.add('is-pop');setTimeout(function(){bun.classList.remove('is-pop')},600);}
            if(name)name.textContent='Dzień '+d+': '+b.n;
            if(counter)counter.textContent=opened;
            if(bar)bar.style.width=(opened/24*100)+'%';
            if(hint)hint.classList.add('is-hidden');
            burst(cell);
          });
        })(cell,b,d);
        grid.appendChild(cell);
      }
      /* ściskanie gniotka na scenie: wciśnij i przytrzymaj, puść -> powoli wraca */
      if(stage){
        var press=function(e){var bun=stage.querySelector('.pm-bun');if(!bun)return;e.preventDefault&&e.preventDefault();bun.classList.remove('is-rise');bun.classList.add('is-squish');};
        var release=function(){var bun=stage.querySelector('.pm-bun');if(!bun||!bun.classList.contains('is-squish'))return;bun.classList.remove('is-squish');bun.classList.add('is-rise');};
        stage.addEventListener('pointerdown',press);
        ['pointerup','pointerleave','pointercancel'].forEach(function(ev){stage.addEventListener(ev,release)});
      }
    });
  }
  function burst(el){
    if(reduce)return;
    var cols=['var(--pm-c1)','var(--pm-c2)','var(--pm-c3)'];
    for(var i=0;i<10;i++){
      var s=document.createElement('i');s.className='pm-spark';
      var a=Math.random()*Math.PI*2,r=34+Math.random()*30;
      s.style.setProperty('--x',Math.cos(a)*r+'px');s.style.setProperty('--y',Math.sin(a)*r+'px');
      s.style.background=['rgb(166,209,58)','rgb(240,104,94)','rgb(255,206,84)','#fff'][i%4];
      el.appendChild(s);setTimeout(function(x){x.remove()},700,s);
    }
  }

  /* --- formularz końcowy: cena wariantu --- */
  function initForms(root){
    root.querySelectorAll('[data-pm-variant]:not([data-ready])').forEach(function(sel){
      sel.setAttribute('data-ready','');
      var form=sel.closest('form'),sec=sel.closest('.pm-section');
      var price=sec&&sec.querySelector('[data-pm-price]');
      sec&&sec.querySelectorAll('[data-pm-pick]').forEach(function(p){
        p.addEventListener('click',function(){
          sel.value=p.getAttribute('data-pm-pick');sel.dispatchEvent(new Event('change'));
        });
      });
      sel.addEventListener('change',function(){
        var o=sel.options[sel.selectedIndex];
        if(price&&o.getAttribute('data-price'))price.textContent=o.getAttribute('data-price');
        sec&&sec.querySelectorAll('[data-pm-pick]').forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-pm-pick')===sel.value)});
      });
    });
  }

  function initAll(root){root=root||document;initReveal(root);initCount(root);initAdvent(root);initForms(root);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll()});else initAll();
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
  window.pmInit=initAll;
})();
